import { FC } from "react";
import { useFormikContext } from "formik";
import classNames from "classnames";
import { CheckboxIndicator } from "@design-system/Checkbox/CheckboxIndicator";
import { ClientFormSchema } from "../AddClientSteps/lib";
import styles from "./AddClientDrawerSteps.module.scss";

export const SelectLedgerStep: FC = () => {
    const { values, setFieldValue } = useFormikContext<ClientFormSchema>();
    const isAccrualLedgerEnabled = values.isAccrualLedgerEnabled;

    const handleAccrualToggle = () => {
        setFieldValue("isAccrualLedgerEnabled", !isAccrualLedgerEnabled);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                Which ledgers do you need for this client?
            </div>
            <div className={styles.subheader}>
                You can update this later in Accounting settings.
            </div>
            <div className={styles.ledgerOptionsContainer}>
                <div className={styles.ledgerOption}>
                    <div className={styles.ledgerOptionContent}>
                        <CheckboxIndicator state="checked" disabled />
                        Cash ledger
                    </div>
                </div>
                <div
                    className={classNames(
                        styles.ledgerOption,
                        styles.clickableOption,
                    )}
                    onClick={handleAccrualToggle}
                    role="button"
                >
                    <div className={styles.ledgerOptionContent}>
                        <CheckboxIndicator
                            state={
                                isAccrualLedgerEnabled ? "checked" : "unchecked"
                            }
                        />
                        <div>
                            Accrual ledger{" "}
                            <span className={styles.accrualLedgerHint}>
                                (requires Plus plan)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
